import type { DocumentsLinkData } from './useDocumentsLinkData.types';

import { isMobileSafari, isSafari } from 'react-device-detect';

import { useMemo, useState } from 'react';

export const useDocumentsLinkData = (): DocumentsLinkData => {
  const [url, setUrl] = useState<DocumentsLinkData['localState']['url']>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const localState = {
    url,
    isModalOpen
  };

  const localActions = {
    setUrl,
    setIsModalOpen
  };

  const formattedData = useMemo(() => {
    return {
      isSafari: isMobileSafari || isSafari
    };
  }, []);

  return {
    localState,
    localActions,
    formattedData
  };
};
